export default {
  automations: [],
  eventEvaluationTemplates: [],
  scheduleRepeatTemplates: [],
  conditionOperators: []
};